import React, { useState } from 'react'
import { Button, Modal, Form } from 'react-bootstrap'

const EditModal = ({ data, onSave, onClose }) => {
  const [formData, setFormData] = useState(data)

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prevData) => ({ ...prevData, [name]: value }))
  }

  const handleSave = () => {
    onSave(formData)
    onClose()
  }

  return (
    <Modal
      show={true}
      onHide={onClose}
    >
      <Modal.Header closeButton>
        <Modal.Title>Edit Modal</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group>
            <Form.Label>ID</Form.Label>
            <Form.Control
              type="text"
              name="ID"
              value={formData.ID}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>IDNFE</Form.Label>
            <Form.Control
              type="text"
              name="IDNFE"
              value={formData.IDNFE}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>CODIGOPRODUTO</Form.Label>
            <Form.Control
              type="text"
              name="CODIGOPRODUTO"
              value={formData.CODIGOPRODUTO}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>EAN</Form.Label>
            <Form.Control
              type="text"
              name="EAN"
              value={formData.EAN}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>PRODUTO</Form.Label>
            <Form.Control
              type="text"
              name="PRODUTO"
              value={formData.PRODUTO}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>NCM</Form.Label>
            <Form.Control
              type="text"
              name="NCM"
              value={formData.NCM}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>MEDIDA</Form.Label>
            <Form.Control
              type="text"
              name="MEDIDA"
              value={formData.MEDIDA}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>QUANTIDADE</Form.Label>
            <Form.Control
              type="text"
              name="QUANTIDADE"
              value={formData.QUANTIDADE}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>VALOR</Form.Label>
            <Form.Control
              type="text"
              name="VALOR"
              value={formData.VALOR}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>VALORTOTAL</Form.Label>
            <Form.Control
              type="text"
              name="VALORTOTAL"
              value={formData.VALORTOTAL}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>ORIG</Form.Label>
            <Form.Control
              type="text"
              name="ORIG"
              value={formData.ORIG}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>CST</Form.Label>
            <Form.Control
              type="text"
              name="CST"
              value={formData.CST}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>CSOSN</Form.Label>
            <Form.Control
              type="text"
              name="CSOSN"
              value={formData.CSOSN}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>CRT</Form.Label>
            <Form.Control
              type="text"
              name="CRT"
              value={formData.CRT}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>BCICMS</Form.Label>
            <Form.Control
              type="text"
              name="BCICMS"
              value={formData.BCICMS}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>PORCICMS</Form.Label>
            <Form.Control
              type="text"
              name="PORCICMS"
              value={formData.PORCICMS}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>VALORICMS</Form.Label>
            <Form.Control
              type="text"
              name="VALORICMS"
              value={formData.VALORICMS}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>BCICMSST</Form.Label>
            <Form.Control
              type="text"
              name="BCICMSST"
              value={formData.BCICMSST}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>PORCICMSST</Form.Label>
            <Form.Control
              type="text"
              name="PORCICMSST"
              value={formData.PORCICMSST}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>VALORICMSST</Form.Label>
            <Form.Control
              type="text"
              name="VALORICMSST"
              value={formData.VALORICMSST}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>BCIPI</Form.Label>
            <Form.Control
              type="text"
              name="BCIPI"
              value={formData.BCIPI}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>PORCIPI</Form.Label>
            <Form.Control
              type="text"
              name="PORCIPI"
              value={formData.PORCIPI}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>VALORIPI</Form.Label>
            <Form.Control
              type="text"
              name="VALORIPI"
              value={formData.VALORIPI}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>DESCONTO</Form.Label>
            <Form.Control
              type="text"
              name="DESCONTO"
              value={formData.DESCONTO}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>IPICST</Form.Label>
            <Form.Control
              type="text"
              name="IPICST"
              value={formData.IPICST}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>PREDBC</Form.Label>
            <Form.Control
              type="text"
              name="PREDBC"
              value={formData.PREDBC}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>PREDBCST</Form.Label>
            <Form.Control
              type="text"
              name="PREDBCST"
              value={formData.PREDBCST}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>PISCST</Form.Label>
            <Form.Control
              type="text"
              name="PISCST"
              value={formData.PISCST}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>PISCST</Form.Label>
            <Form.Control
              type="text"
              name="PISBC"
              value={formData.PISBC}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>PISALIQ</Form.Label>
            <Form.Control
              type="text"
              name="PISALIQ"
              value={formData.PISALIQ}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>PISVALOR</Form.Label>
            <Form.Control
              type="text"
              name="PISVALOR"
              value={formData.PISVALOR}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>COFINSCST</Form.Label>
            <Form.Control
              type="text"
              name="COFINSCST"
              value={formData.COFINSCST}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>COFINSBC</Form.Label>
            <Form.Control
              type="text"
              name="COFINSBC"
              value={formData.COFINSBC}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>COFINSALIQ</Form.Label>
            <Form.Control
              type="text"
              name="COFINSALIQ"
              value={formData.COFINSALIQ}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>COFINSVALOR</Form.Label>
            <Form.Control
              type="text"
              name="COFINSVALOR"
              value={formData.COFINSVALOR}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>CFOP</Form.Label>
            <Form.Control
              type="text"
              name="CFOP"
              value={formData.CFOP}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>SKU_MATCH</Form.Label>
            <Form.Control
              type="text"
              name="SKU_MATCH"
              value={formData.SKU_MATCH}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>DESC_MATCH</Form.Label>
            <Form.Control
              type="text"
              name="DESC_MATCH"
              value={formData.DESC_MATCH}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>MATCH</Form.Label>
            <Form.Control
              type="text"
              name="MATCH"
              value={formData.MATCH}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>CODPRODUTO_MATCH</Form.Label>
            <Form.Control
              type="text"
              name="CODPRODUTO_MATCH"
              value={formData.CODPRODUTO_MATCH}
              onChange={handleChange}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={handleSave}
        >
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default EditModal
